import React from 'react';
import styled from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 14 }} spin />;

const EmptyDetails = ({loading, children}) => {

  return (
    <EmptyDetail>{loading ?
      (<>
        <Spin style={{ marginTop: '-4px' }} indicator={antIcon} />
        <span style={{marginLeft: '10px'}}>Loading...</span></>
      ) : (<span>{children}</span>
      )}
    </EmptyDetail>
  )
}

const EmptyDetail = styled.div`
  color: #cfd3d6;
`

export default EmptyDetails;